<template>
  <div class="comments">
    <div class="object-info__section-content">
      <div class="comments__add-block">
        <el-input
          class="r-input"
          :placeholder="$t('comments:placeholder')"
          @keyup.enter.native="postComment"
          v-model="comment"
          size="mini"
        >
          <el-button
            slot="append"
            icon="el-icon-circle-plus-outline"
            class="comments__add-btn"
            :disabled="isEmptyComment"
            size="mini"
            @click="postComment"
            :loading="isPosting"
          ></el-button>
        </el-input>
      </div>
      <div class="comments__container">
        <div class="comments__list-block">
          <div class="comments__no-data" v-if="!comments.length">
            {{ $t("comments:no-comments") }}
          </div>
          <ul class="comments__list" v-else>
            <li class="comments__item" v-for="item in comments" :key="item.id">
              <div class="comments__avatar">
                <img
                  v-if="userAvatar"
                  :src="`${baseURL}/${downloadURL}/${userAvatar}`"
                  alt="Аватар пользователя"
                />
                <div v-else class="comments__user-no-avatar" />
              </div>
              <div class="comments__comment-block">
                <div class="comments__comment-header">
                  <span class="comments__username">{{ item.username }}</span>
                  <span class="comments__datetime">
                    {{ parseDateTime(item.created_at) }}
                  </span>
                </div>
                <div class="comments__text">{{ item.body }}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import constants from "@/constants/url";
import { errorParser } from "@/utils";

export default {
  props: ["source_id", "id"],
  watch: {
    id: {
      handler: async function() {
        await this.loadComments();
      }
    }
  },
  data() {
    return {
      baseURL: constants.URL,
      downloadURL: "download_share_resource",
      token: this.$store.state.auth.token,
      comments: [],
      comment: "",
      isLoading: false,
      isPosting: false
    };
  },
  computed: {
    userAvatar() {
      return this.$store.state.auth.user.avatar;
    },
    isEmptyComment() {
      return !this.comment.length;
    }
  },
  methods: {
    parseDateTime(created_at) {
      return moment(created_at).format("DD/MM/YYYY HH:mm:ss");
    },
    async postComment() {
      if (!this.comment.length) return;

      this.isPosting = true;
      const url = `objectComments/${this.source_id}/${this.id}?body=${
        this.comment
      }`;
      try {
        await this.$store.dispatch("POST_REQUEST", { url });
        await this.loadComments();
        this.comment = "";
        this.isPosting = false;
      } catch (error) {
        errorParser.call(this, error);
        this.isPosting = false;
      }
    },
    async loadComments() {
      this.isLoading = true;
      const url = `objectComments/${this.source_id}/${this.id}`;
      const { data } = await this.$store.dispatch("REQUEST", { url });
      this.comments = data.reverse();
      this.isLoading = false;
    }
  },
  async created() {
    await this.loadComments();
  }
};
</script>

<style lang="scss">
.comments {
  &__add-btn {
    &.is-disabled,
    &.is-disabled:focus,
    &.is-disabled:hover {
      background-color: transparent !important;
    }
  }
  &__no-data,
  &__loading {
    margin: 10px;
    font-size: 12px;
    color: var(--text_secondary) !important;
  }
  &__list {
    padding: 8px;
    max-height: 200px;
    overflow: auto;
  }
  &__item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 4px 0;
    color: var(--text_secondary) !important;

    &:not(:last-child) {
      border-bottom: 1px solid transparent;
      border-color: var(--dividers_low_contrast) !important;
    }
  }
  &__comment-block {
    margin-left: 10px;
  }

  &__comment-header {
    font-weight: bolder;
    margin-bottom: 5px;
  }
  &__username {
    font-size: 14px;
  }
  &__datetime {
    font-size: 12px;
    font-weight: 300;
    margin-left: 5px;
    color: var(--text_secondary) !important;
  }
  &__text {
    color: var(--text_secondary) !important;
    font-size: 12px;
  }

  &__avatar {
    width: 30px;
    height: 30px;
    position: relative;
    border: 1px solid transparent;
    border-color: var(--dividers_low_contrast) !important;
    overflow: hidden;
    border-radius: 50%;

    img {
      position: absolute;
      width: auto;
      height: 120%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .comments__user-no-avatar {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-image: url("../../assets/images/icons/avatar_white.svg");
      background-size: 75%;
      background-position: 50% 50%;
      background-repeat: no-repeat;
      border: 2px solid transparent;
      border-color: var(--dividers_low_contrast) !important;
    }
  }

  .el-input-group__append {
    border-color: var(--field_border) !important;
    background-color: var(--field_bg) !important;
    color: var(--text_secondary) !important;

    .el-button {
      &.is-disabled {
        border-color: transparent !important;
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "comments:no-comments": "Комментарии отсутствуют",
    "comments:placeholder": "Текст комментария"
  },
  "en": {
    "comments:no-comments": "No comments",
    "comments:placeholder": "Comment text"
  }
}
</i18n>
